import React from "react";

function withTeaserConfig(WrappedComponent, config) {
    const componentWithTeaserConfig = ({data, ...props}) => {
        const newObject = {};
        // renames key from config.key to teaser and assigns it to new object
        delete Object.assign(newObject, data, {teaser: data[config.key] })[config.key];
        return (
            <WrappedComponent data={newObject} {...props}  />
        );
    };

    return componentWithTeaserConfig;
}
export { withTeaserConfig };